// extracted by mini-css-extract-plugin
export default {"topBarContainer":"TopBar_topBarContainer__NShzu","logoTitle":"TopBar_logoTitle__i3yUo","copeLogoTitle":"TopBar_copeLogoTitle__xkPgL","rightTitle":"TopBar_rightTitle__5sEpZ"};